<template>
  <router-view />
</template>

<style lang="less">
#app {
  background-color: #f9f9f9;
  height: 100vh;
  min-height: 45rem;
}

.img_tips {
  display: inline-block;
}

body {
  .el-message--error {
    border: 1px solid #FFC9C9;
    background: #FEEBEB;

    .el-message__content {
      color: #961616;
      font-size: 14px;
    }

    .el-message-icon--error {
      color: #E12121;
    }
  }

  .el-message {
    min-width: 374px;
    height: 52px;
    border-radius: 8px;
    padding: 14px;
    box-shadow: 0px 1.5px 4px -1px #0A090B12;
    // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  }

  .el-message--success {

    border: 1px solid rgba(193, 244, 212, 1);
    background: rgba(235, 251, 241, 1);

    .el-message__content {
      color: rgba(1, 102, 38, 1);
      font-size: 14px;
    }

    .el-message-icon--success {
      color: rgba(1, 102, 38, 1);
    }
  }

  .alert-container {
    z-index: 3000;
  }
}

[id^="sjs-D"] span:nth-child(2) {
  color: red;

}

td[id^="sjs-"] {
  min-width: 40px;
  text-align: center;
  font-size: 11.0pt;
  background: rgb(203, 254, 254);
  border-bottom: 1px #0a090b solid;
  border-right: 1px solid;
}

tr:first-child td[id^="sjs-"] {
  background: rgb(192, 192, 192);
}

td[id^="sjs-F"] {
  min-width: 40px;
  text-align: center;
  font-size: 11pt;
  word-break: break-all;
  text-overflow: hidden;
  word-wrap: normal;
}

.custom-select {
  .el-select__input {
    box-shadow: none;
  }

  .el-select__wrapper {
    border: 1.5px solid rgba(230, 230, 230, 1);
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
    border-radius: 8px;
    padding: 0px 8px 0px 10px;
    height: 40px;
  }

  .el-select__wrapper.is-focused,
  .el-select__wrapper.is-focused:hover {
    /* 更具体的选择器，覆盖hover */
    transition: none;
    border: 1.5px solid rgba(23, 81, 208, 1);
  }

  .el-select__wrapper.is-hovering:not(is-focused),
  .el-select__wrapper:hover {
    border-color: rgba(220, 220, 222, 1);
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
  }

  .el-select__wrapper:focus {
    border: 1.5px solid rgba(230, 230, 230, 1);
    box-shadow: 0px 0px 0px 3px rgba(97, 141, 242, 1);
  }

  .el-select__placeholder.is-transparent {
    color: rgba(127, 125, 131, 1);
  }

  .el-tag.el-tag--info {
    border: 1px solid rgba(230, 230, 230, 1);
    background-color: #fff;
    height: 28px;
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
    color: rgba(79, 77, 85, 1);
    font-weight: 500;
    font-size: 13px;

    .el-tag__close {
      background: url("@/assets/close.svg") no-repeat center center;
      width: 18px;
      /* 根据新图标的尺寸调整 */
      height: 18px;
      background-size: cover;
    }

    .el-tag__close:hover {
      color: rgba(23, 81, 208, 1);
    }

    /* 隐藏原来的 SVG 图标 */
    .el-tag__close svg {
      display: none;
    }
  }

  .el-select__caret {
    color: rgba(79, 77, 85, 1);
    font-weight: 600;
  }
}

body {
  .custom-popper.is-light {
    box-shadow: 0px 0px 0px 1px rgba(10, 9, 11, 0.05);
    border-radius: 8px;
    border: 0;

    .el-select-dropdown__list {
      padding: 6px;
    }

    .el-select-dropdown__item.is-hovering {
      background-color: rgba(248, 248, 248, 1);
      color: rgba(10, 9, 11, 1);
    }

    .el-select-dropdown__item {
      color: rgba(127, 125, 131, 1);
      border-radius: 8px;
      font-size: 14px;
      height: 36px;
      line-height: 36px;
      font-weight: 500;
    }

    .el-time-panel__btn.confirm {
      color: #1751D0;
    }

    .el-select-dropdown.is-multiple .el-select-dropdown__item.is-selected::after {
      background-color: rgba(23, 81, 208, 1);
      width: 1rem;
      height: 1rem;

    }

    .el-select-dropdown__item.is-selected {
      color: rgba(10, 9, 11, 1);
      font-weight: 700;
    }
  }
}

.el-dropdown-link {
  color: rgba(46, 112, 222, 1);
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  display: flex;
  align-items: center;

  .dropdown-icon {
    // transform: rotate(180deg);
    vertical-align: middle;
    // transition: transform linear .3s;
  }
}

.custom-select {
  .el-select__wrapper {
    border: 1.5px solid rgba(230, 230, 230, 1);
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
    border-radius: 8px;
    padding: 0px 8px 0px 10px;
    height: 40px;
  }

  .el-select__wrapper.is-focused,
  .el-select__wrapper.is-focused:hover {
    /* 更具体的选择器，覆盖hover */
    transition: none;
    border: 1.5px solid rgba(23, 81, 208, 1);
  }

  .el-select__wrapper:hover {
    border-color: rgba(220, 220, 222, 1);
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
  }

  .el-select__wrapper:focus {
    border: 1.5px solid rgba(230, 230, 230, 1);
    box-shadow: 0px 0px 0px 3px rgba(97, 141, 242, 1);
  }

  .el-select__placeholder.is-transparent {
    color: rgba(127, 125, 131, 1);
  }

  .el-tag.el-tag--info {
    border: 1px solid rgba(230, 230, 230, 1);
    background-color: #fff;
    height: 28px;
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
    color: rgba(79, 77, 85, 1);
    font-weight: 500;
    font-size: 13px;

    .el-tag__close {
      background: url("@/assets/close.svg") no-repeat center center;
      width: 18px;
      /* 根据新图标的尺寸调整 */
      height: 18px;
      background-size: cover;
    }

    .el-tag__close:hover {
      color: rgba(23, 81, 208, 1);
    }

    /* 隐藏原来的 SVG 图标 */
    .el-tag__close svg {
      display: none;
    }
  }

  .el-select__caret {
    color: rgba(79, 77, 85, 1);
    font-weight: 600;
  }
}

body {
  .custom-popper {
    box-shadow: 0px 0px 0px 1px rgba(10, 9, 11, 0.05);
    border-radius: 8px;
    border: 0;

    .el-select-dropdown__list {
      padding: 6px;
    }

    .el-select-dropdown__item.is-hovering {
      background-color: rgba(248, 248, 248, 1);
      color: rgba(10, 9, 11, 1);
    }

    .el-select-dropdown__item {
      color: rgba(127, 125, 131, 1);
      border-radius: 8px;
      font-size: 14px;
      height: 36px;
      line-height: 36px;
      font-weight: 500;
    }

    .el-select-dropdown.is-multiple .el-select-dropdown__item.is-selected::after {
      background-color: rgba(23, 81, 208, 1);
      width: 1rem;
      height: 1rem;

    }

    .el-select-dropdown__item.is-selected {
      color: rgba(10, 9, 11, 1);
      font-weight: 700;
    }
  }
}

.custom-picker {
  .el-range-editor.el-input__wrapper {
    height: 40px;
    width: 240px;
  }

  .custom-date-picker {
    border: 1.5px solid rgba(230, 230, 230, 1);
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
    border-radius: 8px;
    padding: 0px 8px 0px 10px;
    height: 40px;
    width: 240px;

    .el-range__icon {
      font-size: 18px;
    }

    .el-range-input {
      box-shadow: none;
    }
  }

  .custom-date-picker:hover {
    border-color: rgba(220, 220, 222, 1);
    box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
  }

  .el-range-editor.is-active {
    border-color: rgba(23, 81, 208, 1);
  }
}

.custom-date-popper.is-light {
  border: 1px solid rgba(236, 236, 237, 1);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 0px 3px -1px rgba(10, 9, 11, 0.04);
  box-shadow: 0px 11px 24px -9px rgba(10, 9, 11, 0.14);

}

.custom-date-popper {
  .el-picker-panel__sidebar {
    width: 120px;

    .el-picker-panel__shortcut {
      height: 40px;
      padding-left: 20px;
      font-weight: 500;
      color: rgba(128, 128, 129, 1);
    }

    .el-picker-panel__shortcut:hover {
      color: rgba(23, 81, 208, 1);
    }
  }

  .el-picker-panel__body {
    margin-left: 120px;

    .el-date-range-picker__content.is-left {
      border: 0;
    }

    .el-picker-panel__icon-btn:hover {
      color: rgba(23, 81, 208, 1);
    }

    .el-picker-panel__icon-btn.is-disabled {
      color: rgba(201, 201, 204, 1);
      cursor: no-drop;
    }

    .el-date-table td.end-date .el-date-table-cell__text,
    .el-date-table td.start-date .el-date-table-cell__text {
      background-color: rgba(48, 98, 212, 1);
      color: #fff !important;
    }

    .el-date-table td.available:hover {
      color: rgba(48, 98, 212, 1);
    }

    .el-date-table td.today .el-date-table-cell__text {
      color: rgba(48, 98, 212, 1);
      box-shadow: 0px 1.5px 4px -1px #0A090B12;
    }
  }

}

.custom-form {
  .el-form-item.is-error .el-input__wrapper {
    border-color: #E12121;
    box-shadow: 0px 5px 13px -5px #0A090B0D, 0px 2px 4px -1px #0A090B05;
  }

  .el-form-item.is-error .el-input__wrapper:hover {
    box-shadow: 0px 5px 13px -5px #0A090B0D, 0px 2px 4px -1px #0A090B05;
  }

  .el-form-item.is-error .el-input__wrapper.is-focus {
    box-shadow: 0 0 0px 1px #FFFFFF, 0px 0px 0px 3px #618DF2;
    border: 1.5px solid #E6E6E6;
  }

  .el-form-item__error {
    padding-top: 3px;
    color: #E12121;
    line-height: 18px;
  }

  .el-form-item {
    margin-bottom: 22px;
  }

  .el-form-item__label {
    color: #2D2B32;
    font-weight: 500;
    font-size: 14px;
  }

  .el-form-item__label::before {
    color: #E12121;
  }
}

.custom-input {
  .el-input__wrapper {
    display: flex;
    border: 1.5px solid #E6E6E6;
    align-items: center;
    border-radius: 8px;
    box-shadow: 0px 1.5px 4px -1px #0A090B12;
    padding: 0;
    height: 40px;

    .el-input__inner {
      padding: 0 8px;
      box-shadow: none;
    }
  }

  .el-input__wrapper.is-focus {
    box-shadow: 0 0 0px 1px #FFFFFF, 0px 0px 0px 3px #618DF2;
  }
}

.custom-checkbox,
.custom-checkbox.el-checkbox--large {
  .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(220, 220, 222, 1);
    border-radius: 5px;
    position: relative;
  }

  .el-checkbox__inner:hover {
    border-color: #6C92E4;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: rgba(23, 81, 208, 1)!important;
    border: 2px solid rgba(23, 81, 208, 1)!important;
  }

  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: rgba(23, 81, 208, 1);
    border-color: rgba(23, 81, 208, 1);
  }

  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    height: 5px;
    top: 5.5px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    content: url("data:image/svg+xml;utf8,%3Csvg width='11' height='10' viewBox='0 0 11 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.25L4.5 9C4.5 9 6.5 3.5 9.4 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    display: inline-block;
    /* 可能需要这个来使伪元素正确显示 */
    width: 16px;
    /* 调整宽度 */
    height: 16px;
    /* 调整高度 */
    border: none;
    /* 移除边框 */
    transform: none;
  }

  .el-checkbox__inner::after {
    box-sizing: content-box;
    content: url("data:image/svg+xml;utf8,%3Csvg width='11' height='10' viewBox='0 0 11 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.25L4.5 9C4.5 9 6.5 3.5 9.4 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    border: none;
    /* 移除边框 */
    left: 3px;
    top: 2.5px;
    transform-origin: center;
    /* 确保变形中心正确 */
    transition: transform 0.05s ease-in 50ms;
    /* 如果需要保持过渡效果 */
    position: absolute;
    line-height: 0;
  }

  .el-checkbox__input.is-disabled+span.el-checkbox__label {
    opacity: 0.5;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    opacity: 0.5;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    /* 应用两层 box-shadow，外层大而明显，内层细小且白色 */
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 1),
      /* 内层白色阴影 */
      0 0 0 5px rgba(97, 141, 242, 0.8),
      /* 外层蓝色阴影 */
      0 0 #000;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner:hover {
    background-color: rgba(17, 59, 152, 1);
    border-color: rgba(17, 59, 152, 1);
  }

  .el-checkbox__label {
    color: rgba(51, 60, 70, 1);
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: rgba(10, 9, 11, 1);
  }
}

.custom-table {
  --el-table-header-bg-color: #f9f9f9 !important;

  .el-table__body,
  .el-table__footer {
    font-size: 0.825rem;
  }

  .el-table__header {
    background-color: #f9f9f9;

    th {
      color: #656565;
      font-weight: 500;
      font-size: 0.875rem;
      background-color: #f9f9f9;
    }
  }

  .el-table__header-wrapper {
    background-color: #f9f9f9;
  }

  .el-checkbox__input {
    .el-checkbox__inner {
      background-color: #fff;
      border-width: 2px;
      border-color: #dcdcde;
      border-radius: 5px;
      width: 20px;
      height: 20px;

      &:after {
        content: "";
        // background-color: #1751d0;
      }
    }

    &.is-checked .el-checkbox__inner {
      background-color: #1751d0;
      border-color: #1751d0;

      &:after {
        content: "";
        border-color: #fff;
        border-style: solid;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        height: 10px;
        width: 4px;
        top: 1px;
        left: 5px;
      }
    }

    &.is-indeterminate .el-checkbox__inner {
      background-color: #1751d0;
      border-color: #1751d0;

      &:before {
        content: "";
        background-color: #fff;
        width: 20px;
        height: 4px;
        top: 6px;
        left: -2px;
      }
    }

    &:hover .el-checkbox__inner {
      border-color: darken(#1751d0, 10%);
    }
  }
}

/* 修改升序图标颜色 */
.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #52a86e;
  /* 将颜色改为你选择的颜色 */
}

/* 修改降序图标颜色 */
.el-table .descending .sort-caret.descending {
  border-top-color: #52a86e;
  /* 将颜色改为你选择的颜色 */
}

.el-table .sort-caret.ascending {
  border-bottom-color: #7f7d83;
}

.el-table .sort-caret.descending {
  border-top-color: #7f7d83;
}
</style>
